export default function RecommendedMovie(props) {
    const poster = "https://media.themoviedb.org/t/p/w300_and_h450_face/" + props.posterPath;

    return (
        <div className="card mb-3">
            <div className="row no-gutters">
                <div className="col-md-4">
                    <img className="card-img" src={poster} alt={props.title} />
                </div>
                <div className="col-md-8">
                    <div className="card-body">
                        <h5 className="card-title">{props.title}</h5>
                        <h6 className="card-subtitle mb-2 text-muted">{props.releaseYear}</h6>
                        <p className="card-text">{props.overview}</p>
                        <p className="card-text">
                            <small className="text-muted">
                                {props.genres?.map((genre, index) => (
                                    <span key={genre.id} className="badge badge-pill badge-dark">{genre.name}</span>
                                ))}
                            </small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}